import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { syncCurrentServerFromStorage } from '../redux/reducers/utils/commonReducer';
import { resolveCurrentServer } from '../utils/serverConfig';

const STORAGE_KEY = 'currentServer';

const useCurrentServerSync = () => {
  const dispatch = useDispatch();
  const currentServer = useSelector((store) => store.common.currentServer);

  useEffect(() => {
    const syncFromStorage = (rawValue) => {
      const nextServer = resolveCurrentServer(rawValue);
      if (nextServer !== currentServer) {
        dispatch(syncCurrentServerFromStorage(nextServer));
      }
    };

    syncFromStorage(localStorage.getItem(STORAGE_KEY));

    const handleStorage = (event) => {
      if (event.key !== STORAGE_KEY) {
        return;
      }

      syncFromStorage(event.newValue);
    };

    window.addEventListener('storage', handleStorage);

    return () => {
      window.removeEventListener('storage', handleStorage);
    };
  }, [dispatch, currentServer]);
};

export default useCurrentServerSync;
